export enum SearchOperator {
  Equals = 'EQUALS',
  NotEqual = 'N_EQUAL',
  Contains = 'CONTAINS',
  DoesNotContain = 'N_CONTAIN',
  BeginsWith = 'BEGINS',
  DoesNotBegin = 'N_BEGIN',
  EndsWith = 'ENDS',
  DoesNotEnd = 'N_END',
  MoreThan = 'MORE_THAN',
  NotMoreThan = 'NOT_MORE_THAN',
  MoreThanOrEqual = 'MORE_THAN_OR_EQUAL',
  NotMoreThanOrEqual = 'NOT_MORE_THAN_OR_EQUAL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotLessThan = 'NOT_LESS_THAN',
  NotLessThanOrEqual = 'NOT_LESS_THAN_OR_EQUAL',
}
